import { Input, message, Modal, Spin, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CreateNewNote, NotesTreeView } from "./components";
import { UseApiCallV2, UseLazyApiCallV2 } from "hooks";
import styles from "./styles.module.scss";
import { SearchOutlined } from "@ant-design/icons";
import { CreateCaseIcon, FormLayoutSwitch, SearchIcon } from "icons";
import { useRecoilState } from "recoil";
import { notesListView } from "store/atom";
import { SwitchCasesList } from "icon-components/switchCasesList";
import { ConditionalRenderer } from "components";
import { NotesTable } from "./components/notes-table-layout";
import { useCurrentUserContext } from "providers";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { FileNumberSmile } from "pages/cases-detail/components/file-number-smile";
import { getFilterArrOnSearch } from "utils/helpers";

export const Notes = ({
  collapseOpen,
  refetchCount,
  caseTotalStatuses,
  caseStatus,
  caseStatusLocal,
  setCaseStatusLocal,
}) => {
  const { translator } = useLanguageTranslator();
  const { caseId } = useParams();
  const { user } = useCurrentUserContext();
  const [openCreateNote, setOpenCreateNote] = useState(false);
  const [noteData, setNoteData] = useState(null);
  const [userSearch, setUserSearch] = useState("");
  const [tableListView, setTableListView] = useRecoilState(notesListView);
  const [notesState, setNotesState] = useState([]);

  const [
    deleteNote,
    {
      data: deleteNoteData,
      isLoading: deleteNoteLoading,
      error: deleteNoteError,
    },
  ] = UseLazyApiCallV2({
    url: "/delete_note",
    method: "POST",
  });

  const {
    data: notes,
    isLoading,
    refetch: refetchNotes,
  } = UseApiCallV2({
    url: "/get_note",
    method: "POST",
    paramsData: {
      case_id: caseId,
    },
  });
  useEffect(() => {
    getFilteredData(userSearch);
  }, [userSearch]);

  useEffect(() => {
    setNotesState(notes?.notes);
  }, [notes?.notes]);

  function getFilteredData(userSearch) {
    if (!userSearch) {
      setNotesState(notes?.notes || []);
      return;
    }

    const searchableFields = ["title", "recipient", "name"];

    const filtered = getFilterArrOnSearch({
      searchableFields,
      searchValue: userSearch,
      data: notes?.notes || [],
    });

    setNotesState(filtered);
  }

  function handleOpenCreateNote() {
    setOpenCreateNote(true);
  }
  function handleCloseCreateNote() {
    setOpenCreateNote(false);
    setNoteData(null);
  }

  function onEditNote(noteDataFromChild) {
    setNoteData({ ...noteDataFromChild });
    handleOpenCreateNote();
  }

  async function handleDeleteNote(note_id) {
    try {
      const res = await deleteNote({
        params: {
          note_id,
        },
      });
      if (res?.status === "Success") {
        message.success(res?.message);
        await refetchNotes();
        refetchCount();
      } else {
        message.error(translator("somethingWentWrong"));
      }
    } catch (error) {
      message.error(translator("somethingWentWrong"));
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.searchContainer}>
        <div>
          <FileNumberSmile
            caseTotalStatuses={caseTotalStatuses}
            caseStatus={caseStatus}
            caseStatusLocal={caseStatusLocal}
            setCaseStatusLocal={setCaseStatusLocal}
          />
        </div>
        <div className={styles.messageSearch}>
          <div>
            <Input
              placeholder={translator("Search")}
              onChange={(e) => setUserSearch(e.target.value)}
              prefix={<SearchIcon height={15} width={15} />}
              style={{ height: "39px", width: "346px" }}
              maxLength={40}
              // value={filterInput}
            />
          </div>
          <div
            className={styles.createLicenseBtn}
            onClick={handleOpenCreateNote}
          >
            <CreateCaseIcon height={20} width={20} />
            <div>{translator("caseDetail.notes.createNewNote")}</div>
          </div>
          <Tooltip title={translator("changeLayout")}>
            <div
              style={{ backgroundColor: "white" }}
              // style={{ backgroundColor: tableListView ? "white" : "#cd2a3f" }}
              className={styles.switch}
              onClick={() => setTableListView((prev) => !prev)}
            >
              <FormLayoutSwitch height={22} width={22} />
            </div>
          </Tooltip>
        </div>
      </div>
      <ConditionalRenderer condition={tableListView}>
        <NotesTable
          userSearch={userSearch}
          notes={notesState}
          isLoading={isLoading}
          onEditNote={onEditNote}
          refetchNotes={refetchNotes}
          collapseOpen={collapseOpen}
          handleDeleteNote={handleDeleteNote}
          deleteNoteLoading={deleteNoteLoading}
        />
      </ConditionalRenderer>

      <ConditionalRenderer condition={!tableListView}>
        <NotesTreeView
          notesData={notesState}
          loading={isLoading}
          onEditNote={onEditNote}
          collapseOpen={collapseOpen}
          handleDeleteNote={handleDeleteNote}
          deleteNoteLoading={deleteNoteLoading}
        />
      </ConditionalRenderer>
      <Modal
        destroyOnClose
        // title="Set Reminder"
        open={openCreateNote}
        onCancel={handleCloseCreateNote}
        footer={null}
        centered
        width="95dvw"
        styles={{
          content: {
            backgroundColor: "#F5F6F8",
            height: "85dvh",
          },
          header: { backgroundColor: "#F5F6F8" }, // turns the Modal red
        }}
      >
        <CreateNewNote
          case_id={caseId}
          onCloseModal={handleCloseCreateNote}
          refetchNotes={refetchNotes}
          noteData={noteData}
          refetchCount={refetchCount}
        />
      </Modal>
    </div>
  );
};
